import React from 'react';

import SLICK_PDF from 'assets/slickpay-splash/time-off/doc/employee-evaluation-form.pdf';
import ICON_DOWNLOAD from 'assets/slickpay-splash/time-off/download.svg';
import ICON_IDEAS from 'assets/slickpay-splash/time-off/ideas.svg';
import ICON_STAFF from 'assets/slickpay-splash/time-off/staff.svg';
import ICON_WIN from 'assets/slickpay-splash/time-off/winning.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import C from 'utils/values/constant.util';

import CN from './TimeOffSplashBoxes.module.scss';

const LINK_APPRAISAL = 'http://getslick.com/blog/staff-appraisal';
const LINK_IDEAS = ' http://getslick.com/blog/top-5-ideas-staff-incentives';
const LINK_WIN = 'http://getslick.com/blog/3-winning-commission-structures';

const DATA = C([
  {
    image: ICON_STAFF,
    title: 'How to run a staff appraisal',
    link: LINK_APPRAISAL,
  },
  {
    image: ICON_DOWNLOAD,
    title: 'Download Staff Appraisal form',
    link: SLICK_PDF,
    download: 'Download Staff Appraisal form',
  },
  {
    image: ICON_IDEAS,
    title: 'Top 5 ideas for Staff Incentives',
    link: LINK_IDEAS,
  },
  {
    image: ICON_WIN,
    title: '3 winning commission structures for a salon',
    link: LINK_WIN,
  },
]);

const TimeOffSplashBoxes = () => (
  <div data-bem="TimeOffSplashBoxes">
    <div className={CN.sectionTitle} data-bem="TimeOffSplashBoxes_title">
      <div>Slick Tips & Advice</div>
    </div>

    <section className={CN.flex} data-bem="TimeOffSplashBoxes__body">
      <div className={CN.container} data-bem="TimeOffSplashBoxes__container">
        {DATA.map(({ image, title, link }) => (
          <div key={title} className={CN.box} data-bem="TimeOffSplashBoxes__box">
            <div className={CN.link}>
              <ExternalLink link={link} download>
                <img src={image} alt={title} />
                <span className={CN.linkText}>{title}</span>
                <div>LEARN MORE</div>
              </ExternalLink>
            </div>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default TimeOffSplashBoxes;
